import './form-control.scss';
var FormControl = /** @class */ /*@__PURE__*/ (function () {
    function FormControl() {
    }
    return FormControl;
}());
export { FormControl };
